function initSharedLinkModal() {
  const modal = document.getElementById('shared-link-modal');
  const closeBtn = document.getElementById('slModalClose');
  const linkEl = document.getElementById('scp-app-open');

  if (!modal || !linkEl) return;

  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.includes("android");
  const isIOS = /iphone|ipad|ipod/.test(ua);

  const pathSegments = window.location.pathname
    .split('/')
    .filter(Boolean);

  const pagesIndex = pathSegments.indexOf('pages');

  if (pagesIndex === -1 || !pathSegments[pagesIndex + 1]) {
    return;
  }

  const possibleId = pathSegments[pagesIndex + 2];

  if (possibleId) {

    if (isAndroid) {
      linkEl.href = `intent://sscp-share/${possibleId}#Intent;scheme=smartcontrolplus;package=com.sonova.chb.control;S.browser_fallback_url=${encodeURIComponent("https://play.google.com/store/apps/details?id=com.sonova.chb.control")};end`;
    } else if (isIOS) {
      linkEl.href = `https://www.sennheiser-hearing.com/sscp-share/${possibleId}`;
    } else {
      linkEl.href = "https://play.google.com/store/apps/details?id=com.sonova.chb.control";
    }
    
    modal.style.display = 'none';
    return;
  }

  // No token
  if (isAndroid) {
    linkEl.href = "https://play.google.com/store/apps/details?id=com.sonova.chb.control";
  } else if (isIOS) {
    linkEl.href = "https://apps.apple.com/us/app/sennheiser-smart-control-plus/id6448098057";
  }

  modal.style.display = 'flex';

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }
}

document.addEventListener('DOMContentLoaded', initSharedLinkModal);
document.addEventListener('shopify:section:load', initSharedLinkModal);